<template>
    <a
        class="search-button"
        href="javascript:void(0);"
        @click="open"
    >Search</a>
</template>
<script>
export default {
    methods: {
        open() {
            window.EventHandler.fire('open-search');
        },
    },
};
</script>
